<kort [id]="gruppe().id">
  <div class="kontainer">
    <gruppe-logo [gruppe]="gruppe()" stil="stor"/>
    <div class="informasjon">
      @if(erMalgruppe()){
        <h2 class="tittel e2e-gruppe-mal-navn" data-testid="malnavn">{{ gruppe().gruppemal.navn }}</h2>
        <p class="organisasjonsnavn e2e-gruppe-mal-beskrivelse" data-testid="malbeskrivelse">{{gruppe().gruppemal.beskrivelse}}</p>
      } @else {
        <h2 class="tittel e2e-gruppe-tittel" data-testid="tittel">{{ gruppe().tittel }}</h2>
        <p class="organisasjonsnavn e2e-organisasjon-navn" data-testid="organisasjon">{{ gruppe().organisasjonsnavn }}</p>
        <p class="meta">
          <!-- på én linje for å unngå blankt tegn før komma-->
          <span>{{ antallMedlemmer() }} {{ 'medlemmer'|translate }}@if (antallInviterte() > 0) {, {{ antallInviterte() }} {{ 'inviterte'|translate }}}</span>
          <span>{{ gruppe().antallMoeterInnevaerendeAar }} {{ 'møter i'|translate }} {{ aarstall }}</span>
        </p>
      }
    </div>
  </div>
  @if(harTilgang()){
    <kort-handlinger>
      <button mat-button type="button" (click)="gaaTilGruppe()" data-testid="vis-detaljer">
        <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
        {{ "Vis detaljer"|translate }}
      </button>
    </kort-handlinger>
  } @else {
    <kort-handlinger matTooltip="{{'Du har ikke tilgang til detaljer i denne gruppen'|translate}}">
      <button mat-button type="button" disabled="true" data-testid="vis-detaljer">
        <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
        {{ "Vis detaljer"|translate }}
      </button>
    </kort-handlinger>
  }
</kort>

